import axios from '../utils/axios';

export const getMultimediaProjects = () => {
  return axios.get(`projects/multimediaProjects`).then(response => response.data);
}
export const getProject = id => {
  return axios.get(`projects/${id}/detail`).then(response => response.data);
}
export const getAreaOfInterest = (id, epsg) => {
  return axios.get(`projects/getAreaOfInterest/${id}/${epsg}`).then(response => response.data);
}
export const getMapConfig = (configName) => {
  return axios.get(`services/mapConfig/${configName}`).then(response => response.data);
}

export const getGeoserverKey = () => {
  return axios.get(`services/geoserverKey`).then(response => response.data);
}
export const deleteProject = (id) => {
  return axios.delete(`projects/${id}`).then(response => response.data);
}
export const getProjectProcessingStatus = (id) => {
  return axios.get(`/services/healthMonitoringCheck/${id}`).then(response => response.data);
}
export const restartProject = (id) => {
  return axios.get(`/projects/recalculateProject/${id}`).then(response => response.data);
}

/////forest specific/////
export const getForestFeatures = id => {
  return axios.get(`projects/${id}/forestFeatures`).then(response => response.data);
}
export const saveForestFeatures = (features,id) => {
  return axios.post(`projects/${id}/forestFeatures/save`, features).then(response => response.data);
}
export const calculateCompartment = (compartments) => {
  return axios.post(`geoprocessing/HealthCount`, compartments).then(response => response.data);
}

/////mill specific/////
export const getFeatures = id => {
  return axios.get(`projects/${id}/features`).then(response => response.data);
}
export const saveFeatures = (id,features) => {
  return axios.post(`projects/${id}/features/save`, features).then(response => response.data);
}
export const getTerrainProfile = (profile) => {
  return axios.post(`geoprocessing/TerrainProfile`, profile).then(response => response.data);
}
export const getPolygonVolume = (area) => {
  return axios.post(`geoprocessing/PolygonVolume`, area).then(response => response.data);
}
export const getCoefficient = id => {
  return axios.get(`projects/newCoefficient/${id}`).then(response => response.data);
}

export const getPreviousFeatures = (id,name) => {
  return axios.get(`projects/${id}/previousProfiles/${name}`).then(response => response.data);
}

export const calculateFeatures = (features) => {
  return axios.post(`geoprocessing/CalculateVolumes`, features).then(response => response.data);
}